import {
  EdgeDeviceViewModel,
  PartnerLedgerViewModel,
  PartnerViewModel,
  PlatformPaymentsViewModel,
  SiteOpsViewModel,
  SlipPrintViewModel,
} from "@lumora/core";
import { useMemo } from "react";
import { platformClient } from "../../platformClient.js";

/**
 * Composition root for the platform console: the one place Views get a ViewModel wired to the
 * admin bridge client. Views render VM state and call VM commands; they never touch the client.
 */
export const usePartnerVm = () => useMemo(() => new PartnerViewModel(platformClient), []);

export const usePartnerLedgerVm = (slug: string) =>
  useMemo(() => new PartnerLedgerViewModel(platformClient, slug), [slug]);

export const useEdgeDeviceVm = (slug: string) =>
  useMemo(() => new EdgeDeviceViewModel(platformClient, slug), [slug]);

export const useSlipPrintVm = (slug: string) =>
  useMemo(() => new SlipPrintViewModel(platformClient, slug), [slug]);

export const usePlatformPaymentsVm = () =>
  useMemo(() => new PlatformPaymentsViewModel(platformClient), []);

export const useSiteOpsVm = () => useMemo(() => new SiteOpsViewModel(platformClient), []);
